import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resumeSubscription } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { SubscriptionDto } from '@/types/subscription';

export const useResumeSubscription = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionDto, unknown, void>({
        mutationFn: resumeSubscription,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.changeHistory() });
        },
    });
};
